// @ commons
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const { OPENYOUNG_ACCOUNT_STANDARD } = require('constants/index');
import { VIEWER } from 'constants/contactCenter/pdfViewer';
// @ helpers
const { downloadAsFile } = require('utilities/APIRequestHelper');
import { openPDFViewer, showPDFFailure } from 'utilities/contactCenter/pdfViewer';
// @ actions
const cardsCanceledActions = require('actions/cardsCanceled');

const getPreContractualsInProgress = () => ({
    type: actionTypes.FETCH_PRE_CONTRACTUALS_REQUEST
});

const getPreContractualsSuccess = (response) => ({
    type: actionTypes.FETCH_PRE_CONTRACTUALS_SUCCESS,
    payload: {
        precontracts: response
    }
});

const getPreContractualsFailure = (error) => ({
    type: actionTypes.FETCH_PRE_CONTRACTUALS_FAILURE,
    payload: {
        error
    }
});

const getPreContractuals = (params) => (dispatch) => {
    const requestData  = {
        query: {
            "estandar": params.standard,
            "idioma": 1, // @ hardcoded
            "subtipo": params.subtipo,
            "tipo": params.tipo
        }
    };

    dispatch(getPreContractualsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('requestPreContract'), requestData)
        .then(response => dispatch(getPreContractualsSuccess(response)))
        .catch(error => dispatch(getPreContractualsFailure(error)));
}

const getSaddeDocumentsInProgress = () => ({
    type: actionTypes.FETCH_SADDE_DOCUMENTS_REQUEST
});

const getSaddeDocumentsSuccess = (response) => ({
    type: actionTypes.FETCH_SADDE_DOCUMENTS_SUCCESS,
    payload: {
        documents: response
    }
});

const getSaddeDocumentsFailure = (error) => ({
    type: actionTypes.FETCH_SADDE_DOCUMENTS_FAILURE,
    payload: {
        error
    }
});

const getSaddePdfDocumentsRequest = process => ({
    type: actionTypes.FETCH_SADDE_PDF_DOCUMENTS_REQUEST,
    payload: {
        process
    }
});

const getSaddePdfDocumentsSuccess = process => ({
    type: actionTypes.FETCH_SADDE_PDF_DOCUMENTS_SUCCESS,
    payload: {
        process
    }
});

const getSaddePdfDocumentsFailure = process => ({
    type: actionTypes.FETCH_SADDE_PDF_DOCUMENTS_FAILURE,
    payload: {
        process
    }
});

const getSaddePdfDocumentPreviewRequest = () => ({
    type: actionTypes.FETCH_SADDE_PDF_DOCUMENT_PREVIEW_REQUEST
});

const getSaddePdfDocumentPreviewSuccess = response => ({
    type: actionTypes.FETCH_SADDE_PDF_DOCUMENT_PREVIEW_SUCCESS,
    payload: {
        documents: response
    }
});

const getSaddePdfDocumentPreviewFailure = error => ({
    type: actionTypes.FETCH_SADDE_PDF_DOCUMENT_PREVIEW_FAILURE,
    payload: {
        error
    }
});

const getSaddeDocuments = (params) => (dispatch) => {

    const requestData = {
        query: [
            {
                "name": "NUMCUENTA",
                "operator": "EQ",
                "value": params.contractId
            }
        ]
    };

    dispatch(getSaddeDocumentsInProgress());

    return APIPost(dispatch, apiURLBuilder.getURL('requestSaddeDocuments'), requestData)
        .then(response => dispatch(getSaddeDocumentsSuccess(response)))
        .catch(error => dispatch(getSaddeDocumentsFailure(error)));
};

const getFileSaddeDocuments = (fileParams, filename, loadType = undefined) => (dispatch) => {
    const params = {
        query: {
            "process": fileParams.get('process'),
            "internalIdx": fileParams.get('internalIdx'),
            "segmentId": fileParams.get('segmentId'),
            "pageTo": fileParams.get('pageTo'),
            "queryId": fileParams.get('queryId')
        },
        header: {
            responseType: 'arraybuffer'
        }
    };

    dispatch(getSaddePdfDocumentsRequest(fileParams.get('process')));

    return APIGet({
        dispatch,
        params,
        endpoint: 'requestSaddeDocumentsDownload'
    })
    .then(response => {
        if (!loadType) {
            downloadAsFile(response.xhr.response, 'application/pdf', filename + '.pdf');
        } else if (loadType === VIEWER) {
            openPDFViewer(response.xhr.response);
        }
        dispatch(getSaddePdfDocumentsSuccess(fileParams.get('process')));
    })
    .catch(() => {
        if (loadType === VIEWER) {
            showPDFFailure();
        }
        dispatch(getSaddePdfDocumentsFailure(fileParams.get('process')));
    });
};

const previewFileSaddeDocuments = (params) => (dispatch) => {
    const requestData = {
        query: {
            "referencia": {
                "estandar": OPENYOUNG_ACCOUNT_STANDARD, //0000001
                "subtipo": params.subtipo,
                "tipo": params.tipo
            }
        }
    };

    dispatch(getSaddePdfDocumentPreviewRequest());

    return APIPost(dispatch, apiURLBuilder.getURL('requestPDFPreviewPreContract'), requestData)
        .then(response => dispatch(getSaddePdfDocumentPreviewSuccess(response)))
        .catch(error => dispatch(getSaddePdfDocumentPreviewFailure(error)));
};

const getIbanRequest = () => ({
    type: actionTypes.FETCH_IBAN_REQUEST
});

const getIbanSuccess = () => ({
    type: actionTypes.FETCH_IBAN_SUCCESS
});

const getIbanFailure = (error) => ({
    type: actionTypes.FETCH_IBAN_FAILURE,
    payload: {
        error
    }
});

const getCardsIban = (params) => (dispatch, getState) => {
    let isCardCanceled = false;
    let card = getState().cards.get('byId').filter(card => card.get('number').replace(/\s+/g, '') === params.contractId.replace(/\s+/g, '')).first();
    if (!card) {
        card = getState().cardsCanceled.get('byId').filter(card => card.get('number').replace(/\s+/g, '') === params.contractId.replace(/\s+/g, '')).first();
        isCardCanceled = true;
    }
    const requestData = {
        header: {
            version: 3
        },
        query: {
            pan: params.contractId,
            numeroContrato: card.getIn(['contract', 'number']),
            producto: card.getIn(['contract', 'product'])
        }
    };

    dispatch(getIbanRequest());

    return APIPost({
        dispatch,
        endpoint: 'cardInformation',
        params: requestData
    })
    .then(response => {
        dispatch(getIbanSuccess());
        params.success((response.codIban.codbban));
        if (isCardCanceled) {
            dispatch(cardsCanceledActions.setHolderCanceledCard(response.nombreBeneficiario, card.get('cardId')));
        }
    })
    .catch(error => dispatch(getIbanFailure(error)));
};

const getLoansIban = (params) => (dispatch, getState) => {
    const loan = getState().loans.get('byId').get(params.contractId);

    const requestData = {
        query: {
            numeroContrato: loan.get('newContractNumber'),
            producto: loan.get('newProduct')
        }
    };

    dispatch(getIbanRequest());

    return APIGet({
        dispatch,
        endpoint: 'loansAndMortgages',
        params: requestData
    })
    .then(response => {
        dispatch(getIbanSuccess());
        params.success(response.cuentaAsociada.codbban);
    })
    .catch(error => dispatch(getIbanFailure(error)));
};

module.exports = {
    getPreContractuals,
    getSaddeDocuments,
    getFileSaddeDocuments,
    getCardsIban,
    getLoansIban,
    previewFileSaddeDocuments
};
